import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/app/MainPage.tsx");
